import React, {ComponentProps, FC} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Colors, ShadowCard, Text} from '@optimaxdev/design-system';

import {TYP_ORDER_CONFIRMATION, TYP_SEE_DETAILS} from 'constants/analytics/events/typ';

const TYP_GREETING_ID_FOR_CHAT = '61a6e6c74d5a746adc0eb046';

/**
 * Reloading and opening chat for the TYP page
 */
export const setChatForTYP = () => {
    window.adaEmbed?.reset({
        greeting: TYP_GREETING_ID_FOR_CHAT,
    });
    window.adaEmbed?.toggle();
};

/**
 * Gets the common text props
 */
export const getCommonTextProps = (isDesktop: boolean): ComponentProps<typeof Text> => ({
    as: 'p',
    color: Colors.limedSpruce,
    lineHeight: isDesktop ? '26px' : 'auto',
    size: isDesktop ? '16px' : '14px',
});
/**
 * Gets the common text props
 */
export const getCommonTitleProps = (isDesktop: boolean): ComponentProps<typeof Text> => ({
    as: 'p',
    bold: true,
    color: Colors.limedSpruce,
    lineHeight: isDesktop ? '24px' : '20px',
    margin: '0 0 8px',
    size: isDesktop ? '16px' : '14px',
});

/**
 * Renders either a normal div or shadowcard based on isDesktop prop
 */
export const Wrapper: FC<{isDesktop: boolean; children: React.ReactNode; className: string}> = ({
    children,
    className,
    isDesktop,
}) =>
    isDesktop ? (
        <div className={className}>{children}</div>
    ) : (
        <ShadowCard className={className} corner={4} saturate={1}>
            {children}
        </ShadowCard>
    );
/**
 * Send Desktop analytics on chat open
 */
export const handleAnalyticsOnChatOpen = (hasClickedSeeDetails: boolean) => {
    const isDesktop = __BUILD_TYPE__ === 'desktop';

    if (hasClickedSeeDetails && isDesktop) {
        sendDesktopAnalyticsEvent(
            TYP_SEE_DETAILS,
            {
                label: "Let's Chat",
            },
            true,
        );
    }
};

/**
 * Send Desktop analytics on dropdown toggle
 */
export const handleAnalyticsOnDropdownToggle = () => {
    const isDesktop = __BUILD_TYPE__ === 'desktop';

    if (isDesktop) {
        sendDesktopAnalyticsEvent(
            TYP_ORDER_CONFIRMATION,
            {
                label: 'Shipping & Billing Info',
            },
            true,
        );
    }
};
